import { GlobalStyle, Container, Logo, Title, Wrapper, ButtonPrimary } from "../../../common";
import { useParams } from "react-router-dom";

import { useCallback, useEffect, useRef, useState } from "react";
import { useRealtimeChannel } from "../../../common/services/realtime/realtime-hook";
import { RealtimeActions } from "../../../common/services/realtime/realtime-actions";
import { InfoMonitorConnection, LoadImage } from "./style";
import { urlsPages } from "../../../common/urls/urls-pages";
import { UrlUtils } from "../../../config/utils/url-utils";

const CONNECT_ATTEMPT_UI_MS = 15_000;

export const MonitorConnectionUi = () => {
    const { sessionId } = useParams();
    const { messages, publish } = useRealtimeChannel<string>(sessionId ?? "");
    const [connecting, setConnecting] = useState(false);
    const connectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const clearConnectTimeout = useCallback(() => {
        if (connectTimeoutRef.current !== null) {
            clearTimeout(connectTimeoutRef.current);
            connectTimeoutRef.current = null;
        }
    }, []);

    useEffect(() => {
        clearConnectTimeout();
        setConnecting(false);
    }, [sessionId, clearConnectTimeout]);

    useEffect(() => {
        return () => {
            clearConnectTimeout();
        };
    }, [clearConnectTimeout]);

    useEffect(() => {
        messages.forEach((message) => {
            console.log("message real time", message);
            if (message === RealtimeActions.SESSION_ACK) {
                clearConnectTimeout();
                window.location.href = UrlUtils.goToPage(urlsPages.monitor, sessionId ?? "");
            }
        });
    }, [messages, sessionId, clearConnectTimeout]);

    const handleConnect = async () => {
        setConnecting(true);
        clearConnectTimeout();
        try {
            await publish(RealtimeActions.SESSION_SYN);
        } catch {
            setConnecting(false);
            return;
        }
        connectTimeoutRef.current = setTimeout(() => {
            connectTimeoutRef.current = null;
            setConnecting(false);
        }, CONNECT_ATTEMPT_UI_MS);
    };

    return (
        <>
            <GlobalStyle />
            <Container>
                <Wrapper center={true}>
                    <Logo center={true} />
                    <Title>Conexão monitor</Title>
                    {connecting ? (
                        <InfoMonitorConnection>
                            <LoadImage src="/assets/images/load-gif2.gif" alt="Loading" />
                            Conectando...
                        </InfoMonitorConnection>
                    ) : (
                        <ButtonPrimary width="180px" onClick={handleConnect} margintop="180px">
                            Conectar
                        </ButtonPrimary>
                    )}
                </Wrapper>
            </Container>
        </>
    );
};
